"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.impossibleFinancialResponsibilityCaseSchema = void 0;
const zod_1 = require("zod");
const constants_1 = require("../constants");
const FinancialResponsibilityTypes_1 = require("../enums/FinancialResponsibilityTypes");
const StateCodes_1 = require("../enums/StateCodes");
exports.impossibleFinancialResponsibilityCaseSchema = zod_1.z.object({
    state: zod_1.z.optional(zod_1.z.nativeEnum(StateCodes_1.StateCodes)),
    type: zod_1.z.optional(zod_1.z.nativeEnum(FinancialResponsibilityTypes_1.FinancialResponsibilityTypes)),
    caseNumber: constants_1.defaultOptionalString,
}).strict();
